import classNames from 'classnames'
import styles from './TooltipTrigger.module.css'
import { Icon } from '../Icon'
import { TooltipTriggerProps } from './types'

const TooltipTrigger = ({ type = 'question', title = 'More information', className }: TooltipTriggerProps) => {
  return (
    <button className={classNames(styles.tooltipTrigger, className)} type="button">
      <Icon name={type} title={title} />
    </button>
  )
}

export default TooltipTrigger
